<script>
export default {
  name: 'BaseFormGroup',
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default: null,
      validator(value) {
        return /^[a-zA-Z][\w:.-]*$/.test(value)
      },
    },
    label: {
      type: String,
      default: null,
    },
    extraLabel: {
      type: String,
      default: null,
    },
    inline: Boolean,
    hasErrors: Boolean,
    vuelidate: {
      type: Object,
      default: () => {},
    },
    required: Boolean,
  },
}
</script>

<template>
  <div>
    <label
      v-if="label"
      :for="id"
      class="flex items-center justify-between mb-3 cursor-pointer"
    >
      <span>{{ label }}</span>

      <span>
        <span>{{ extraLabel }}</span>
        <slot name="extra-label" />
      </span>
    </label>

    <slot />

    <div
      v-if="hasErrors"
      class="mx-3 mt-2 text-sm text-right errors text-volunteer_red"
    >
      <p v-if="vuelidate && !vuelidate.required">
        This field is required.
      </p>
      <slot name="errors" />
    </div>
  </div>
</template>
